export const displayContentsList = [
  { value: true },
  { value: false },
]
